/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tenant_Danger_Token_SharedInputs */



/**
* | output |
* | --- |
* | "This server uses the shared bot; there's no token to store." |
*
* @param {Tenant_Danger_Token_SharedInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const tenant_danger_token_shared = /** @type {((inputs?: Tenant_Danger_Token_SharedInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tenant_Danger_Token_SharedInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Этот сервер работает на общем боте — сохранять токен не нужно.")
	return /** @type {LocalizedString} */ ("This server uses the shared bot; there's no token to store.")
});